import DeleteResourceInteractor from "../../core/interactor/app/crud/DeleteResourceInteractor";
import Constants from "../common/Constants";

export default class DeleteCaseLawDocumentInteractor {
  private resource: DeleteResourceInteractor;

  constructor({ deleteResource }: any) {
    this.resource = deleteResource;
  }

  async execute(caseLawDocumentId: number) {
    return this.resource.execute(Constants.endpointBasePath, caseLawDocumentId);
  }
}
